import React from 'react'
import { Icon } from 'antd'
import styles from './AuthLayoutNew.less'
import logo from '../assets/vision-login-page.gif'
import { Link } from 'react-router-dom'
import moment from 'moment'

class UserLayout extends React.PureComponent {
    render() {
        const { children } = this.props
        return (
            <div className={styles.authWrapper}>
                <div className={styles.authContainer}>
                    {/* Left Side: Branding & Illustration */}
                    <div className={styles.visualSide}>
                        <div className={styles.visualContent}>
                            <img src={logo} alt="Branding" className={styles.heroGif} />
                            <h1 className={styles.welcomeText}>Empowering Your Vision</h1>
                            <p className={styles.subText}>Secure access to your administrative dashboard.</p>
                        </div>
                        {/* Abstract background shapes moved here for visual depth */}
                        <div className={styles.decoration}>
                            <span className={styles.shape1}></span>
                            <span className={styles.shape2}></span>
                        </div>
                    </div>

                    {/* Right Side: Form Content */}
                    <div className={styles.formSide}>
                        {/* <div className={styles.formHeader}>
                            <Link to="/">
                                <Icon type="arrow-left" /> Back to Website
                            </Link>
                        </div> */}

                        <div className={styles.formWrapper}>
                            {children}
                        </div>

                        <div className={styles.formFooter}>
                            <span>&copy; {moment().format('YYYY')} T-Vision. All rights reserved.</span>
                            {/* <div className={styles.footerLinks}>
                                <a>Help</a>
                                <a>Privacy</a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserLayout